import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import type { RangeOption } from "../../constants/epicLeaderboard";
import { useMyPlayer } from "../../context/MyPlayerContext";
import { playerPath } from "../../utils/playerLink";
import type { PlayerTab } from "../../utils/playerLink";

type Props = {
  player: string;
  range?: RangeOption;
  tab?: PlayerTab;
  className?: string;
  children?: ReactNode;
};

// Link to a player's page; marked `is-me` when it is the viewer's own saved
// character, so every list on the site can highlight them.
const PlayerLink = ({ player, range, tab, className, children }: Props) => {
  const { isMe } = useMyPlayer();
  const classes = [className, isMe(player) ? "is-me" : null]
    .filter(Boolean)
    .join(" ");
  return (
    <Link to={playerPath({ player, range, tab })} className={classes || undefined}>
      {children ?? player}
    </Link>
  );
};

export default PlayerLink;
